module.exports = __webpack_public_path__ + "media/images/psych_quiz/favicon-eadcc520e26ec22c857a42408d374882.png";